import SubscriptionsSelector from '../SubscriptionsSelector'
import { hardwareRequirementsUrl } from '../../constants'
import { softwareExplainedUrl } from '../../constants'
import moment from 'moment'

export default ({ t, i18n, products, setSubscription, subscription, addToCart, cart, language, softwareLinksMap }) => (
  <div className="content">
    <div className="m-b-lg">
      <h5 className="is-size-5 m-b-md">{t('pcm-title')}</h5>
      <p><a href={softwareExplainedUrl(i18n.language)} target="_blank">{t('common:subscription-common')}</a></p>
      <div className="columns">
        <div className="column is-8">
          <p>{t('common:pcm-content-1')}</p>
          <p>{t('common:pcm-content-2')}</p>
          <ul>
            <li>{t('common:pcm-content-2-1')}</li>
            <li>{t('common:pcm-content-2-2')}</li>
          </ul>
          <p>{t('common:pcm-content-3')}</p>
          <p>{t('common:pcm-content-6')}</p>
          <ul>
            <li>{t('common:pcm-content-7', {
                version: softwareLinksMap['MDSFA'].name,
                date: moment(softwareLinksMap['MDSFA'].release_date).format('MM/DD/YYYY')
              })}</li>
            <li>{t('common:pcm-content-13', {
                version: softwareLinksMap['MDSFA_UPDATE'].name
              })}</li>
          </ul>
          <p>{t('common:pcm-content-14')}</p>
          <p>{t('common:pcm-content-4')}</p>
          <ul>
            <li>
              {t('common:pcm-content-5', {
                version: softwareLinksMap['MMP'].name,
                date: moment(softwareLinksMap['MMP'].release_date).format('MM/DD/YYYY')
              })}
            </li>
          </ul>
        </div>

        <div className="column">
          <p>{t('common:pcm-content-9')}</p>
          <p>{t('common:pcm-content-10')}</p>
          <p>{t('common:pcm-content-11')}</p>
          <p>{t('common:pcm-content-12')}</p>
        </div>
      </div>

      <div className="m-b-md">
        {t('common:pcm-content-8-1')}&nbsp;
        <a href={hardwareRequirementsUrl(i18n.language)}
          target="_blank">
          {t('common:pcm-content-8-2')}
        </a>
      </div>

      <SubscriptionsSelector
        products={products}
        subscription={subscription}
        setSubscription={setSubscription}
        addToCart={addToCart}
        cart={cart}
        language={language}
        t={t} />
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./components/PCMReflashing/index.js